import React from 'react';
import styles from '../../portModal.module.scss';
import { IntervalTimeout, IPAddress, TimeoutConstant, TimeoutMultiplier } from '../sections';
type Props = {
	ipAddressValidation: boolean;
	onResetIPAddressValidation: () => void;
	errorMessage: string;
	onResetErrorMessage: () => void;
};

const AdvancedSettings: React.FC<Props> = ({ ipAddressValidation, onResetIPAddressValidation, errorMessage, onResetErrorMessage }) => {
	return (
		<div className={styles.form}>
			<div className={styles.advancedSettingsContainer}>
				<fieldset>
					<legend className={styles.legend}>{_('TimeoutSettings')}</legend>
					<TimeoutMultiplier />
					<TimeoutConstant />
					<IntervalTimeout />
				</fieldset>
			</div>
			<div>
				<IPAddress
					ipAddressValidation={ipAddressValidation}
					onResetIPAddressValidation={onResetIPAddressValidation}
					errorMessage={errorMessage}
					onResetErrorMessage={onResetErrorMessage}
					useAdvancedAddress={true}
				/>
			</div>
		</div>
	);
};

export { AdvancedSettings };
